import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
var mixin = css(["max-width:500px;flex:1;display:flex;flex-direction:column;row-gap:10px;"]);
export var Container = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__Container",
  componentId: "keen-widget-settings__ei0g8o-0"
})(["&&&{display:flex;min-height:320px;}"]);
export var SettingsColumnLeft = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__SettingsColumnLeft",
  componentId: "keen-widget-settings__ei0g8o-1"
})(["&&&{", ";padding-right:72px;}"], mixin);
export var SettingsColumnRight = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__SettingsColumnRight",
  componentId: "keen-widget-settings__ei0g8o-2"
})(["&&&{", ";border-left:1px solid ", ";padding-left:20px;}"], mixin, colors.gray[300]);
export var InputWrapper = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__InputWrapper",
  componentId: "keen-widget-settings__ei0g8o-3"
})(["&&&{max-width:310px;width:100%;}"]);
export var Row = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__Row",
  componentId: "keen-widget-settings__ei0g8o-4"
})(["&&&{display:flex;align-items:center;justify-content:space-between;column-gap:10px;", ";", ";}"], space, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var ControlContainer = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__ControlContainer",
  componentId: "keen-widget-settings__ei0g8o-5"
})(["&&&{display:flex;justify-content:space-between;align-items:center;", ";}"], function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var SelectColumnInfoWrapper = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__SelectColumnInfoWrapper",
  componentId: "keen-widget-settings__ei0g8o-6"
})(["&&&{width:100%;display:flex;justify-content:center;}"]);
export var SelectColumnInfo = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__SelectColumnInfo",
  componentId: "keen-widget-settings__ei0g8o-7"
})(["&&&{margin-top:20px;padding:30px 20px;display:flex;justify-content:center;align-items:center;background:", ";border:1px solid ", ";border-radius:4px;box-sizing:border-box;height:63px;}"], transparentize(0.8, colors.green[100]), colors.green[100]);
export var InfoIconWrapper = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__InfoIconWrapper",
  componentId: "keen-widget-settings__ei0g8o-8"
})(["&&&{margin-right:10px;}"]);
export var FormatInfo = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__FormatInfo",
  componentId: "keen-widget-settings__ei0g8o-9"
})(["&&&{background:", ";border-left:3px solid ", ";padding:10px;}"], colors.lightBlue[100], colors.lightBlue[400]);
export var TitleWrapper = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__TitleWrapper",
  componentId: "keen-widget-settings__ei0g8o-10"
})(["&&&{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}"]);
export var TitleActions = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__TitleActions",
  componentId: "keen-widget-settings__ei0g8o-11"
})(["&&&{display:flex;align-items:center;}&&& button{margin-left:10px;}"]);
export var DropdownInfo = styled.div.withConfig({
  displayName: "FormatTableSettingsstyles__DropdownInfo",
  componentId: "keen-widget-settings__ei0g8o-12"
})(["&&&{padding:10px 13px;background:", ";}"], colors.gray[100]);